import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import localeEnZA from '@angular/common/locales/en-ZA';

import { IonicConfig } from '@ionic/core';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { IonicStorageModule } from '@ionic/storage';

import { ElvisDSModule, ThemeService } from 'ngx-elvis-ds';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { GUIModule } from './gui/gui.module';
import { environment } from 'src/environments/environment';
import { LocaleProvider } from './locale.provider';
import { WindowRef } from './window-ref.service';

// const config: SocketIoConfig = { 
//   url: environment.guiHelperURL,
//   options: {
//     reconnectionDelay: 30000,
//     query: {
//       guiPathName: window.location.pathname
//     }
//   }
// };

registerLocaleData(localeEn, 'en');
registerLocaleData(localeEnZA, 'en-ZA');
registerLocaleData(localeIt, 'it');

const AppConfig: IonicConfig = {
  mode: 'md',
  hardwareBackButton: false,
  spinner: 'dots',
  loadingSpinner: 'dots',
  animated: true,
};

@NgModule({
    declarations: [
      AppComponent,
    ],
    imports: [
      BrowserModule,
      HttpClientModule,
      // SocketIoModule.forRoot(config),
      IonicStorageModule.forRoot(),
      IonicModule.forRoot(AppConfig),
      AppRoutingModule,
      GUIModule,
      ElvisDSModule.forRoot(),
    ],
    providers: [
      StatusBar,
      SplashScreen,
      LocaleProvider,
      WindowRef,
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    ],
    bootstrap: [
      AppComponent
    ]
})
export class AppModule {}
